import { Grid } from '@mui/material';
import { memo, ReactElement } from 'react';
import { AccordionProfessionTitle } from 'shell/view-models/accordion-profession-title';
import { FormikErrors, FormikTouched } from 'formik';
import NotProfessionalConditionList from 'shell/components/shared/not-professional-condition-list';
import TitleStudyList from 'shell/components/shared/title-study-list';
import StationList from 'shell/components/shared/station-list';

interface ProfessionTitleFormProps {
  disabled?: boolean;
  values?: AccordionProfessionTitle;
  isEditMode?: boolean;
  errors?: FormikErrors<AccordionProfessionTitle>;
  touched?: FormikTouched<AccordionProfessionTitle>;
  onChange: (
    key: keyof AccordionProfessionTitle,
    value: AccordionProfessionTitle[keyof AccordionProfessionTitle]
  ) => void;
  onChangeValues: (values: AccordionProfessionTitle) => void;
  children?: ReactElement;
}

const ProfessionTitleFormComponent = ({
  disabled,
  values,
  onChange,
  errors,
  touched,
  isEditMode,
  onChangeValues,
  children,
}: ProfessionTitleFormProps): React.ReactElement => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <StationList
          label="Posizione professionale"
          aria-label="Posizione professionale"
          value={values?.professionalPosition || ''}
          disabled={isEditMode ? false : disabled}
          onChange={(value, item) => {
            onChangeValues({ professionalPosition: value, professionalPositionItem: item });
          }}
          error={touched?.professionalPosition && Boolean(errors?.professionalPosition)}
        />
      </Grid>
      <Grid item xs={12}>
        <NotProfessionalConditionList
          label="Condizione non professionale"
          aria-label="Condizione non professionale"
          value={values?.unprofessionalCondition || ''}
          disabled={isEditMode ? false : disabled}
          onChange={(element) => {
            onChange('unprofessionalCondition', element);
          }}
          error={touched?.unprofessionalCondition && Boolean(errors?.unprofessionalCondition)}
        />
      </Grid>
      <Grid item xs={12}>
        <TitleStudyList
          label="Titolo di studio"
          aria-label="Titolo di studio"
          value={values?.educationalQualification || ''}
          disabled={isEditMode ? false : disabled}
          onChange={(element) => {
            onChange('educationalQualification', element);
          }}
          error={touched?.educationalQualification && Boolean(errors?.educationalQualification)}
        />
      </Grid>
      {children ? (
        <Grid item xs={12}>
          {children}
        </Grid>
      ) : undefined}
    </Grid>
  );
};

ProfessionTitleFormComponent.displayName = 'Form Profession or Title component';

const ProfessionTitle = memo(ProfessionTitleFormComponent);

export default ProfessionTitle;
